import { RenewalSequenceStep } from '../../../models/Concession'

interface SequenceInput {
    name: string
    is_active: boolean
    steps: RenewalSequenceStep[]
}

export const validateSequence = (
    input: SequenceInput,
): Record<string, string> => {
    const errors: Record<string, string> = {}

    if (!input.name.trim()) {
        errors.name = 'Name is required'
    }

    const nonDelaySteps = input.steps.filter((s) => s.step_type !== 'DELAY')
    if (nonDelaySteps.length === 0) {
        errors._steps =
            'At least one communication step (Email, SMS, or Portal) is required'
    }

    input.steps.forEach((step, index) => {
        const key = `step_${index}`

        switch (step.step_type) {
            case 'EMAIL':
                if (!step.subject?.trim()) {
                    errors[`${key}_subject`] = 'Subject is required'
                    errors[key] = errors[key] || 'Email step is incomplete'
                }
                if (!step.content?.trim()) {
                    errors[`${key}_content`] = 'Content is required'
                    errors[key] = errors[key] || 'Email step is incomplete'
                }
                break

            case 'SMS':
                if (!step.content?.trim()) {
                    errors[`${key}_content`] = 'Message content is required'
                    errors[key] = errors[key] || 'SMS step is incomplete'
                }
                break

            case 'PORTAL':
                if (!step.subject?.trim()) {
                    errors[`${key}_subject`] = 'Subject is required'
                    errors[key] = errors[key] || 'Portal step is incomplete'
                }
                if (!step.content?.trim()) {
                    errors[`${key}_content`] = 'Content is required'
                    errors[key] = errors[key] || 'Portal step is incomplete'
                }
                break

            case 'DELAY':
                if (!step.delay_days || step.delay_days < 1) {
                    errors[`${key}_delay`] = 'Delay must be at least 1 day'
                    errors[key] = errors[key] || 'Delay step is incomplete'
                }
                break
        }
    })

    return errors
}
